import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { useNavigate } from "react-router-dom";
import { useMerchantRoutes } from "../merchant-routes";

export const SignupFormsReplacedByPopupsModal = ({
  handleDismiss,
  handleComplete,
}: {
  handleDismiss: () => void;
  handleComplete?: () => void;
}) => {
  const navigate = useNavigate();
  const routes = useMerchantRoutes();
  return (
    <RedoModal
      onModalCloseRequested={handleDismiss}
      primaryButton={{
        text: "Go to Popups",
        onClick: () => {
          navigate(routes.getMarketingPopupsSubRoute(""));
          handleComplete?.();
        },
      }}
      secondaryButton={{ text: "Dismiss", onClick: handleDismiss }}
      title="Spotlights renamed to Popups, replacing signup forms"
    >
      <Flex dir="column" gap="sm">
        <Text>
          Spotlights are out of beta and have been renamed to Popups! New
          sign-up forms cannot be created, but existing sign-up forms will
          continue to work and can still be modified, activated/deactivated, and
          submitted by shoppers like normal. Over the next 2-3 weeks, existing
          sign-ups will be migrated to Popups with no work needed on your part.
        </Text>
      </Flex>
    </RedoModal>
  );
};
